import { useState, useEffect  } from 'react';
import axios from "axios";
import { useSelector, useDispatch } from 'react-redux';
import { likewriterActions } from "_store";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import { history } from '_helpers';
export { SingleWriteEssay };

function SingleWriteEssay() {
  const dispatch = useDispatch();
  const [text, setText] = useState("");
  const { user: authUser } = useSelector((x) => x.auth);
  const { likewriter } = useSelector((x) => x.likewriter);
  const [correctedText, setCorrectedText] = useState("");
  const [errors, setErrors] = useState([]);
  const [score, setScore] = useState(null);
  const [loading, setLoading] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const [wordCount, setWordCount] = useState(0);
  const [sentenceCount, setSentenceCount] = useState(0);
  const [selectedOption, setSelectedOption] = useState("Without Countdown Timer");
  const [textInput, setTextInput] = useState("");
  const { essayid } = useParams();
  const [ grammarScore, setGrammarScore] = useState(0);
  const [ vocabularyScore, setVocabularyScore] = useState(0);
  const [ cohesionScore, setCohesion] = useState(0);
  const [ organizationScore, setOrganization] = useState(0);
  const [ contentScore, setContent] = useState(0);
  const [ grammarFeedback, setGrammarFeedback] = useState('');
  const [ vocabularyFeedback, setVocabularyFeedback] = useState('');
  const [ cohesionFeedback, setCohesionFeedback] = useState('');
  const [ organizationFeedback, setOrganizationFeedback] = useState('');
  const [ contentFeedback, setContentFeedback] = useState('');
  const [timeLeft, setTimeLeft] = useState(60 * 60); // 60 minutes in seconds
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const [saving, setSaving] = useState(false);
  const [lexileScore, setLexileScore] = useState(null);
  const YOUR_OPENAI_API_KEY = 'Bearer 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';
  const handleRadioChange = (e) => {
    setSelectedOption(e.target.value);
    if (e.target.value === "With Countdown Timer") {
      setTimeLeft(60 * 60); // Reset timer to 60 minutes
      setIsTimerRunning(true);
    } else {
      setIsTimerRunning(false);
    }
  };
  const handleTextInputChange = (e) => setTextInput(e.target.value);
  const handleGrammarCheck = async () => {
    if (!text.trim()) {
      alert("Please write an essay and submit it again for a grammar check.");
      return;
    }
  
    setLoading(true);
    try {
      const response = await axios.post(
        "https://api.openai.com/v1/chat/completions",
        {
          model: "gpt-4o",
          messages: [
            {
              role: "user",
              content: `Evaluate the following essay:
              ${text}
      
              Provide a JSON response with:
        - Content & Ideas (score out of 100 + feedback)
        - Organization (score out of 100 + feedback)
        - Grammar & Mechanics (score out of 100 + feedback)
        - Vocabulary Use (score out of 100 + feedback)
        - Coherence & Cohesion (score out of 100 + feedback)
        - Total Score (out of 100)
        - Corrected text
        - Errors (list of wrong words and suggestions)
        - Grammar punctuation score (0-100)
        - Vocabulary score (0-100)
        - Character count, word count, and sentence count.
        - **Lexile Score** (a numerical value estimating the reading difficulty level)
        

        Ensure all scores are out of 100. Respond in JSON format only (no explanations, no markdown).`,
            },
          ],
          temperature: 0,
    top_p: 0,
    seed: 1234
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: YOUR_OPENAI_API_KEY,
          },
        }
      );
      
      // Clean the response by removing any triple backticks and unnecessary formatting
      let responseDataText = response.data.choices[0].message.content.trim();
      responseDataText = responseDataText.replace(/```json|```/g, "").trim();
     
  
      const responseData = JSON.parse(responseDataText);
      // Extract and rename the fields
const {
  "Lexile Score": lexile_score, // Add this line
  "Content & Ideas": content_ideas,
  "Organization": organization,
  "Grammar & Mechanics": grammar_mechanics,
  "Vocabulary Use": vocabulary_use,
  "Coherence & Cohesion": coherence_cohesion,
  "Total Score": total_score,
  "Corrected text": corrected_text,
  "Errors": errors,
  "Character count": character_count,
  "Word count": word_count,
  "Sentence count": sentence_count,
} = responseData;
setLexileScore(lexile_score);
      setCorrectedText(corrected_text);
      setErrors(errors);
      setScore(total_score);
      setCharCount(character_count);
      setWordCount(word_count);
      setSentenceCount(sentence_count);
      setGrammarScore(grammar_mechanics.score);
      setVocabularyScore(vocabulary_use.score);
      setContent(content_ideas.score);
      setOrganization(organization.score);
      setCohesion(coherence_cohesion.score);
      setGrammarFeedback(grammar_mechanics.feedback);
      setVocabularyFeedback(vocabulary_use.feedback);
      setContentFeedback(content_ideas.feedback);
      setOrganizationFeedback(organization.feedback);
      setCohesionFeedback(coherence_cohesion.feedback);
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    }
    setLoading(false);
  };
  
  useEffect(() => {
        dispatch(likewriterActions.getEssayById({ essayid }));
  }, []);

  useEffect(() => {
   if(likewriter  && likewriter.data){
    console.log(likewriter.data,'get likewriter data');
    setTextInput(likewriter.data.title);
    setText(likewriter.data.essay);
    setCorrectedText(likewriter.data.corrected_text);
    setErrors(JSON.parse(likewriter.data.errors));
    setCharCount(likewriter.data.character_count);
    setWordCount(likewriter.data.word_count);
    setSentenceCount(likewriter.data.sentence_count);
    setLexileScore(likewriter.data.lexile_score);
    var grammar_mechanics = JSON.parse(likewriter.data.grammar_mechanics);
    var vocabulary_use = JSON.parse(likewriter.data.vocabulary_use);
    var content_ideas = JSON.parse(likewriter.data.content);
    var organization = JSON.parse(likewriter.data.organization);
    var coherence_cohesion = JSON.parse(likewriter.data.coherence_cohesion);
    setGrammarScore(grammar_mechanics.score);
    setVocabularyScore(vocabulary_use.score);
    setContent(content_ideas.score);
    setOrganization(organization.score);
    setCohesion(coherence_cohesion.score);
    setGrammarFeedback(grammar_mechanics.feedback);
    setVocabularyFeedback(vocabulary_use.feedback);
    setContentFeedback(content_ideas.feedback);
    setOrganizationFeedback(organization.feedback);
    setCohesionFeedback(coherence_cohesion.feedback);
   }
}, [likewriter]);

  console.log(errors,'likewriter');

  // const handlePrint = () => {
  //   const printContent = document.getElementById("printableContent").innerHTML;
  //   const originalContent = document.body.innerHTML;
  
  //   document.body.innerHTML = printContent;
  //   window.print();
  //   document.body.innerHTML = originalContent;
  // }; 

 
  const handlePrint = () => {
    const printElements = document.querySelectorAll(".write-essay-title-input, .strikethrough-boldfaces-text, .chatgpt-corrected-text");
    
    let printContent = ""; 
    printElements.forEach(element => {
      let textContent = "";
  
      // If the element contains an input field, extract its value
      const inputField = element.querySelector("input, textarea");
      if (inputField) {
        textContent = inputField.value;
      } 
      // If it's the strikethrough text, use innerHTML to preserve formatting
      else if (element.classList.contains("strikethrough-boldfaces-text")) {
        textContent = element.innerHTML; // Preserve bold/strikethrough
      } 
      // Otherwise, use innerText for plain text
      else {
        textContent = element.innerText;
      }
  
      printContent += `<p>${textContent}</p>`; // Wrap in <p> for layout consistency
    });
  
    // Create an iframe for printing
    const printFrame = document.createElement("iframe");
    printFrame.style.position = "absolute";
    printFrame.style.width = "0px";
    printFrame.style.height = "0px";
    printFrame.style.border = "none";
  
    document.body.appendChild(printFrame);
    printFrame.contentDocument.open();
    printFrame.contentDocument.write(`
      <html>
        <head>
          <title>Print</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            p { margin-bottom: 10px; font-size: 16px; }
            .strikethrough-boldfaces-text del { text-decoration: line-through; } /* Ensure strikethrough styling */
          </style>
        </head>
        <body>
          ${printContent}  
        </body>
      </html>
    `);
    printFrame.contentDocument.close();
  
    // Trigger print
    printFrame.contentWindow.focus();
    printFrame.contentWindow.print();
  
    // Remove the iframe after printing
    setTimeout(() => {
      document.body.removeChild(printFrame);
    }, 1000);
  };
  

  // function to downlaod report
  const handleReportDownload = () => {
    const printWindow = window.open("", "_blank"); // Open new print window
    const tableHTML = document.querySelector(".table-responsive").innerHTML; // Get table HTML

    printWindow.document.write(`
        <html>
            <head>
                <title>Table Report</title>
                <style>
                    body { font-family: Arial, sans-serif; text-align: center; }
                    table { width: 100%; border-collapse: collapse; }
                    th, td { border: 1px solid black; padding: 8px; text-align: left; }
                </style>
            </head>
            <body>
                <h2>Table Report</h2>
                ${tableHTML} <!-- Insert table content -->
                <script>
                    window.onload = function() { window.print(); window.close(); };
                </script>
            </body>
        </html>
    `);
    printWindow.document.close();
};

  // const calculateAverage = (vocabScore, grammarScore,organizationScore,contentScore,cohesionScore) => {
  //   const number1 = parseFloat(vocabScore);
  //   const number2 = parseFloat(grammarScore);
  //   const number3 = parseFloat(organizationScore);
  //   const number4 = parseFloat(contentScore);
  //   const number5 = parseFloat(cohesionScore);

  //   if (!isNaN(number1) && !isNaN(number2) && !isNaN(number3) && !isNaN(number4) && !isNaN(number5)) {
  //     return (number1 + number2 + number3 + number4 + number5) / 5;
  //   } else {
  //     return 0;
  //   }
  // };


  const handleSave = async () => {
    if (!text.trim() || !textInput.trim()) {
      alert("Please enter a title and content before saving.");
      return;
    }
    setSaving(true);
    try {

      const response = await axios.post(
        "https://api.openai.com/v1/chat/completions",
        {
          model: "gpt-4o",
          messages: [
            {
              role: "user",
              content: `Evaluate the following essay:
              ${text}
      
              Provide a JSON response with:
        - Content & Ideas (score out of 100 + feedback)
        - Organization (score out of 100 + feedback)
        - Grammar & Mechanics (score out of 100 + feedback)
        - Vocabulary Use (score out of 100 + feedback)
        - Coherence & Cohesion (score out of 100 + feedback)
        - Total Score (out of 100)
        - Corrected text
        - Errors (list of wrong words and suggestions)
        - Grammar punctuation score (0-100)
        - Vocabulary score (0-100)
        - Character count, word count, and sentence count.
        - **Lexile Score** (a numerical value estimating the reading difficulty level)
        Ensure all scores are out of 100. Respond in JSON format only (no explanations, no markdown).`,
            },
          ],
          temperature: 0,
    top_p: 0,
    seed: 1234
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: YOUR_OPENAI_API_KEY,
          },
        }
      );
      
      // Clean the response by removing any triple backticks and unnecessary formatting
      let responseDataText = response.data.choices[0].message.content.trim();
      responseDataText = responseDataText.replace(/```json|```/g, "").trim();
     
  
      const responseData = JSON.parse(responseDataText);
      // Extract and rename the fields
const {
  "Lexile Score": lexile_score, // Add this line
  "Content & Ideas": content_ideas,
  "Organization": organization,
  "Grammar & Mechanics": grammar_mechanics,
  "Vocabulary Use": vocabulary_use,
  "Coherence & Cohesion": coherence_cohesion,
  "Total Score": total_score,
  "Corrected text": corrected_text,
  "Errors": errors,
  "Character count": character_count,
  "Word count": word_count,
  "Sentence count": sentence_count,
} = responseData;
setLexileScore(lexile_score);
      setCorrectedText(corrected_text);
      setErrors(errors);
      setScore(total_score);
      setCharCount(character_count);
      setWordCount(word_count);
      setSentenceCount(sentence_count);
      setGrammarScore(grammar_mechanics.score);
      setVocabularyScore(vocabulary_use.score);
      setContent(content_ideas.score);
      setOrganization(organization.score);
      setCohesion(coherence_cohesion.score);
      setGrammarFeedback(grammar_mechanics.feedback);
      setVocabularyFeedback(vocabulary_use.feedback);
      setContentFeedback(content_ideas.feedback);
      setOrganizationFeedback(organization.feedback);
      setCohesionFeedback(coherence_cohesion.feedback);
       var student_id = authUser.user.student_id;
       var teacher_id = authUser.user.teacher_id;
       var title = textInput;
       var essay = text;
     if (essayid) {
      //Update existing essay
      await dispatch(
        likewriterActions.updateEssay({
          id: essayid,
          student_id,
          teacher_id,
          title,
          essay,
          character_count,
          word_count,
          sentence_count,
          vocabulary_use: JSON.stringify(vocabulary_use),
          corrected_text,
          errors: JSON.stringify(errors),
          content: JSON.stringify(content_ideas),
          organization: JSON.stringify(organization),
          grammar_mechanics: JSON.stringify(grammar_mechanics),
          coherence_cohesion: JSON.stringify(coherence_cohesion),
          total_score,
          lexile_score,
        })
      );
    } else {
      //Create new essay
      await dispatch(
        likewriterActions.createEssay({
          student_id,
          teacher_id,
          title,
          essay,
          character_count,
          word_count,
          sentence_count,
          vocabulary_use: JSON.stringify(vocabulary_use),
          corrected_text,
          errors: JSON.stringify(errors),
          content: JSON.stringify(content_ideas),
          organization: JSON.stringify(organization),
          grammar_mechanics: JSON.stringify(grammar_mechanics),
          coherence_cohesion: JSON.stringify(coherence_cohesion),
          total_score,
          lexile_score,
        })
      );
    }

  toast.success('Essay saved successfully.', {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    });
    //history.navigate('/essay/MyWritingList');
    } catch (error) {
      console.error("Save Error:", error);
      //alert("An error occurred while saving. Please try again.");
    }
    setSaving(false);
  };
  

  const handleStopAndSave = () => {
    setIsTimerRunning(false);
    handleSave();
  };

  useEffect(() => {
    if (isTimerRunning && timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [isTimerRunning, timeLeft]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };
  const getGrammarScoreMessage = (score) => {
    const percentageRanges = {
      1: "10-30%",
      2: "31-50%",
      3: "51-70%",
      4: "81-90%",
      5: "91-100%",
    };
  
    return `Your grammar score is ${percentageRanges[score] || "Unknown"}.`;
  };

  const getVocabularyLevelMessage = (score) => {
    return `The level of vocabulary used in your writing is Level ${score || "Unknown"}.`;
  };

  return (
    <section className="custom-sign write-essay">
    <div className="container">
     {/* Buttons */}
     <div className="write-essay-buttons" style={{ display: "flex", gap: "10px" }}>
          <button onClick={handleGrammarCheck} disabled={loading}>{loading ? "Checking..." : "Grammar & Spell Checker"}</button>
          <button onClick={handlePrint}>Print</button>
          <button onClick={handleReportDownload}>Download Report</button>
          <button onClick={handleSave} disabled={saving}>{saving ? "Saving..." : "Save"}</button>
        </div>
  
        {/* Title Input */}

        <div className="write-essay-title-input">
        <input
          type="text"
          placeholder="Type title here"
          value={textInput || (likewriter && likewriter.data) ? likewriter.data.title : ''}
          onChange={handleTextInputChange}
          style={{ width: "100%", padding: "8px", display: "block" }}
        />
        </div>
      {/* Textarea Input */}
      <div className="like-writer-textarea" style={{ marginBottom: "10px" }}>
      <textarea
        placeholder="Type or paste your text here..."
        value={text || (likewriter && likewriter.data) ? likewriter.data.essay : ''}
        onChange={(e) => setText(e.target.value)}
        rows="5"
        style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
      ></textarea>
      </div>
      <div id="printableContent" style={{ display: "none" }}>
  {/* Print Title */}
  <h2>{textInput}</h2>

  {/* Print Corrected Text */}
  <p className="strikethrough-boldfaces-text1">
    {(() => {
      if (!text) return null;
      let modifiedText = text;
      errors.forEach((error) => {
        if (!error.wrong || !error.suggestion) return;
        const escapedWrong = error.wrong.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(escapedWrong, "g");
        modifiedText = modifiedText.replace(regex, 
          `<span style="text-decoration: line-through; color: red;">${error.wrong}</span> 
           &nbsp;<span style="font-weight: bold; color: green;">${error.suggestion}</span>`);
      });
      return <span dangerouslySetInnerHTML={{ __html: modifiedText }} />;
    })()}
  </p>
</div>

      {/* Corrected Output with Strikethrough and Bold */}
{correctedText && (
  <div style={{ marginTop: "20px", padding: "10px", border: "1px solid #ccc", background: "#f8f8f8" }}>

<p className="strikethrough-boldfaces-text">
  {(() => {
    if (!text) return null; // Handle empty text case

    let modifiedText = text;

    errors.forEach((error) => {
      // Determine the correct property name dynamically
      const wrongKey = error.wrong || error.wrong_word;
      const suggestion = error.suggestion;

      if (!wrongKey || !suggestion) return; // Skip invalid entries

      const escapedWrong = wrongKey.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special regex characters
      const regex = new RegExp(escapedWrong, "g");

      modifiedText = modifiedText.replace(regex, 
        `<span style="text-decoration: line-through; color: red;">${wrongKey}</span> 
         &nbsp;<span style="font-weight: bold; color: green;">${suggestion}</span>`);
    });

    return <span dangerouslySetInnerHTML={{ __html: modifiedText }} />;
  })()}
  <span className="arrow-section">↓</span>
</p>

{/* <p className="strikethrough-boldfaces-text">
  {(() => {
    if (!text) return null; // Handle empty text case

    let modifiedText = text;

    errors.forEach((error) => {
      if (!error.wrong || !error.suggestion) return; // Skip invalid error entries

      const escapedWrong = error.wrong.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special regex characters
      const regex = new RegExp(escapedWrong, "g");

      modifiedText = modifiedText.replace(regex, 
        `<span style="text-decoration: line-through; color: red;">${error.wrong}</span> 
         &nbsp;<span style="font-weight: bold; color: green;">${error.suggestion}</span>`);
    });

    return <span dangerouslySetInnerHTML={{ __html: modifiedText }} />;
  })()}
  <span className="arrow-section">↓</span>
</p> */}

    <p className="chatgpt-corrected-text">
    <span>{correctedText}</span>
    </p>
  </div>
)}


<Table striped bordered responsive>
    <thead>
      <tr>
        <th colSpan={5} style={{ textAlign: "center" }}>
        LIKE Editor Score Report
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Name</td>
        <td>{authUser.user.name}</td>
        <td rowspan="5" className="result">
          {(score || likewriter?.data?.total_score) >= 50 ? <h4 style={{ color: "green" }}>Pass ({lexileScore}L)</h4>: <h4 style={{ color: "red" }}>Fail ({lexileScore}L)</h4>}
        </td>
      </tr>
      <tr>
        <td>Test Date</td>
        <td>{new Date().toLocaleDateString("en-US", {
    month: "long",
    day: "2-digit",
    year: "numeric",
  })}</td>
      </tr>
      <tr>
        <td>Character Count</td>
        <td>{charCount || likewriter?.data?.character_count}</td>
      </tr>
      <tr>
        <td>Word Count</td>
        <td>{wordCount || likewriter?.data?.word_count}</td>
      </tr>
      <tr>
        <td>Sentence Count</td>
        <td>
        {sentenceCount || likewriter?.data?.sentence_count}
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Scores</td>
        <td colSpan={5}>Comments</td>
      </tr>
      <tr>
        <td>Content</td>
        <td>{contentScore}</td>
        <td colSpan={5}> {contentFeedback}</td>
      </tr>
      <tr>
        <td>Organization</td>
        <td>{organizationScore}</td>
        <td colSpan={5}> {organizationFeedback}</td>
      </tr>
      <tr>
        <td>Grammar and Mechanics</td>
        <td>{grammarScore }</td>
        <td colSpan={5}> {grammarFeedback}</td>
      </tr>
      <tr>
        <td>Vocabulary Use</td>
        <td>{vocabularyScore}</td>
        <td colSpan={5}> {vocabularyFeedback}</td>
      </tr>
      <tr>
        <td>Coherence and Cohesion</td>
        <td>{cohesionScore }</td>
        <td colSpan={5}>{cohesionFeedback}</td>
      </tr>
      <tr>
        <td>Overall Evaluation</td>
        <td>{score || likewriter?.data?.total_score}</td>
        <td colSpan={5}>Your writing shows relatively low proficiency and skills. It contains some noticeable mistakes and errors in grammar, punctuation, organization, usage, and style, and they sometimes hinder the meanings.</td>
      </tr>

    </tbody>
  </Table>
      {/* Text Statistics */}
      <div className="write-essay-count" style={{ marginTop: "20px", padding: "10px", border: "1px solid #ccc", background: "#f2f2f2" }}>
        <p><strong>Character Count:</strong> {charCount}</p>
        <p><strong>Word Count:</strong> {wordCount}</p>
        <p><strong>Sentence Count:</strong> {sentenceCount} </p>
      </div>
      <div className="write-essay-grammar-spelling-issue" style={{ ax: "20px", padding: "10px", border: "1px solid #ccc", background: "#f2f2f2" }}>
        <p><strong>{(errors && errors.length > 0) ? errors.length : 0}</strong> Grammar & Spelling issues</p>
       
      </div>
    </div>
    </section>
  );
}
